import pcoUrl from "pco-url"

export default class API {
  static apiBase() {
    return `${pcoUrl(window.railsEnv)("api")}/registrations/v2`
  }

  static get(path) {
    path = path.startsWith("/") ? path : `/${path}`

    return fetch(`${this.apiBase()}${path}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include"
    }).then(resp => resp.json())
  }

  static getAll = (path, options = {}, records = []) => {
    const offset = records.length
    const defaultOptions = { perPage: 25 }
    const { perPage } = Object.assign({}, defaultOptions, options)

    const joinChar = path.match(/\?/) ? "&" : "?"
    const fullPath = `${path}${joinChar}offset=${offset}&per_page=${perPage}`

    return this.get(fullPath).then(response => {
      response.data = records.concat(response.data)
      response.meta.count = response.data.length

      if (response.meta.total_count > response.data.length) {
        return this.getAll(path, options, response.data)
      } else {
        return response
      }
    })
  }

  static post(path, data, callback) {
    path = path.startsWith("/") ? path : `/${path}`

    return fetch(`${this.apiBase()}${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include",
      body: new Blob([JSON.stringify({ data })])
    })
      .then(resp => resp.json())
      .then(resp => {
        if (callback !== undefined) {
          callback(resp)
        } else {
          return resp
        }
      })
  }

  static del(path, callback) {
    path = path.startsWith("/") ? path : `/${path}`

    return fetch(`${this.apiBase()}${path}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include"
    })
      .then(resp => {
        if (resp.ok) {
          return resp.status
        } else {
          return resp.json()
        }
      })
      .then(resp => {
        if (callback !== undefined) {
          callback(resp)
        }
      })
  }

  static patch(path, data, callback) {
    path = path.startsWith("/") ? path : `/${path}`

    return fetch(`${this.apiBase()}${path}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include",
      body: new Blob([JSON.stringify({ data })])
    })
      .then(resp => resp.json())
      .then(resp => {
        if (callback !== undefined) {
          callback(resp)
        }
      })
  }

  static patchOrPost(resource, path, data, callback) {
    if (resource && resource.id) {
      return API.patch(path, data, callback)
    }
    return API.post(path, data, callback)
  }
}
